<div class="input_box">
    
    <mat-form-field appearance="fill" [style.width.%]=100>
  
        <mat-label>{{inputParameters.name}}</mat-label>
        
        <input 
            *ngIf="inputParameters.required" 
            
            min={{inputParameters.minValue}} 
            max={{inputParameters.maxValue}} 
            step={{inputParameters.stepValue}} 
            placeholder="" 
            matInput   [matDatepicker]="picker"
            [formControl]="dateFormControl"
            [errorStateMatcher]="matcher" 
            required
            autocomplete="off">

        <input 
            *ngIf="!inputParameters.required" 

            min={{inputParameters.minValue}} 
            max={{inputParameters.maxValue}} 
            step={{inputParameters.stepValue}} 
            placeholder="" 
            matInput   [matDatepicker]="picker"
            [formControl]="dateFormControl"
            [errorStateMatcher]="matcher" 
            autocomplete="off">
            
        <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
        <mat-datepicker #picker></mat-datepicker>


      
    </mat-form-field>
    
  </div> 